import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./Navbar.css";
import logo from "./logoEcoleZero.svg";

function Navbar() {
  const location = useLocation();

  // const isViewportWide = window.innerWidth > 925;

  return (
    <>
      <div className="row align-items-center">
        <div className="col-lg-12 d-flex justify-content-center">
          <Link to="/">
            <img src={ logo } className="logo" alt="Logo Ecole Zéro" />
          </Link>
        </div>

            {/* <p className="text-secondary small fst-italic">
              École Zéro est une association à but non lucratif fondée en 2020 dont l'objectif est de réfléchir aux différentes manières de «&nbsp;faire école&nbsp;» collectivement, en mettant en relation l'aménagement du territoire avec différents champs disciplinaires et en proposant notamment d'explorer les territoires hors métropole. Elle est un espace de rencontre, de partage, de recherche et d'expérimentation à différentes échelles et sous des formes alternatives de création ouvert à tous·tes et s'adressant à une grande diversité d'acteur·ices public·ques et privé·es.
            </p> */}

        <div className="row mt-4 align-items-center">
          <div className="col-lg-12 d-flex flex-wrap justify-content-center text-center">
            <Link to="/" className={`nav-tab ${ location.pathname === "/" ? "active" : "" }`}>
              Actualités{ location.pathname === "/" ? " ↓" : "" }
            </Link>

            <span className="v-separator">|</span>

            <Link to="/about" className={`nav-tab ${ location.pathname.includes("/about") ? "active" : "" }`}>
              À&nbsp;propos{ location.pathname.includes("/about") ? " ↓" : "" }
            </Link> 

            <span className="v-separator">|</span>

            <Link to="/sessions" className={`nav-tab ${ location.pathname.includes("/sessions") ? "active" : "" }`}>
              Sessions{ location.pathname.includes("/sessions") ? " ↓" : "" }
            </Link> 

            <span className="v-separator">|</span>

            <Link to="/publications" className={`nav-tab ${ location.pathname.includes("/publications") ? "active" : "" }`}>
              Publications{ location.pathname.includes("/publications") ? " ↓" : "" }
            </Link>

            <span className="v-separator">|</span>

            <Link to="/sounds" className={`nav-tab ${ location.pathname.includes("/sounds") ? "active" : "" }`}>
              Médias{ location.pathname.includes("/sounds") ? " ↓" : "" }
            </Link>
            
            </div>
            </div>

      
      </div>
      <div className="row mt-2 mb-3">
        <div className="col">
          <span className="h-separator"></span>
        </div>
      </div>
    </>
  )
  
}

export default Navbar;